import { combineReducers } from 'redux';
import appReducer from './appReducer';
import EbSearchState from './EbSearchState';
import EntityDetails from './EntityDetails';
import InformationViewReducer from './InformationViewReducer';
import ModuleState from './ModuleState';
import PcSearchState from './PcSearchState';
import EbPlansAndServicesState from './EbPlansAndServicesState';
import EbProfileViewReducer from './EbProfileViewReducer';
import SearchResultsReducer from './SearchResultsReducer';
import UserSavedSearchState from './UserSavedSearchState';
import PcPoliciesAndModsState from './PcPoliciesAndModsState';
import EventSubscriptionState from './EventSubscriptionReducer';

const rootReducer = combineReducers({
  appReducer,
  EbPlansAndServicesState,
  EbProfileViewReducer,
  EbSearchState,
  EntityDetails,
  InformationViewReducer,
  ModuleState,
  PcPoliciesAndModsState,
  PcSearchState,
  SearchResultsReducer,
  UserSavedSearchState,
  EventSubscriptionState,
});

export default rootReducer;
